import { render, staticRenderFns } from "./mineNewssixth.vue?vue&type=template&id=04c17fbb&scoped=true"
import script from "./mineNewssixth.vue?vue&type=script&lang=js"
export * from "./mineNewssixth.vue?vue&type=script&lang=js"
import style0 from "./mineNewssixth.vue?vue&type=style&index=0&id=04c17fbb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c17fbb",
  null
  
)

export default component.exports